import { TUTORIAL_STEPS, TUTORIAL_SECTIONS } from "../constants/tutorialSteps";

export function filterStepsForUser(permissions, title, phase, isLocationScoped) {
    const isOwner = title === "owner" || title === "admin";

    return TUTORIAL_STEPS.filter((step) => {
        if (step.phase !== phase) return false;

        const { requires } = step;
        if (!requires) return true;

        if (requires.ownerOnly && !isOwner) return false;

        if (requires.locationScoped && !isLocationScoped) return false;

        if (requires.permissions && requires.permissions.length > 0) {
            const hasAll = requires.permissions.every(
                (perm) => permissions?.[perm] && permissions[perm] !== 0
            );
            if (!hasAll) return false; 
        }

        return true;
    });
}

export function filterAllStepsForUser(permissions, title, maxPhase, isLocationScoped) {
    const isOwner = title === "owner" || title === "admin";

    return TUTORIAL_STEPS.filter((step) => {
        if (step.phase > maxPhase) return false;

        const { requires } = step;
        if (!requires) return true;

        if (requires.ownerOnly && !isOwner) return false;

        if (requires.locationScoped && !isLocationScoped) return false;

        if (requires.permissions && requires.permissions.length > 0) {
            const hasAll = requires.permissions.every(
                (perm) => permissions?.[perm] && permissions[perm] !== 0
            );
            if (!hasAll) return false;
        }

        return true;
    });
}

export function getVisibleSections(filteredSteps) {
    const sectionIds = new Set(filteredSteps.map((s) => s.section));
    return TUTORIAL_SECTIONS.filter((sec) => sectionIds.has(sec.id));
}

export function getStepsForSection(filteredSteps, sectionId) {
    return filteredSteps.filter((s) => s.section === sectionId);
}
